/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ComboDetailPage = lazyLoad(
  () => import('./index'),
  module => module.ComboDetailPage
);
